import React, { Component } from 'react';
import { connect } from 'react-redux';
import { panagramsArr, textPalettes, textBorderPalettes } from './constants/Panagrams';
import uuid from 'uuid';
import './Panagram.css';

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class Panagram extends Component {
  constructor(props) {
    super(props);
    this.getRandomStyle = this.getRandomStyle.bind(this);
  }

  getRandomStyle() {
    const {
      fonts,
    } = this.props;

    const {
      primary,
    } = fonts;

    let style = {}
    if (Math.random() >= 0.5) {
      const randomPalette = textPalettes[Math.floor(Math.random() * textPalettes.length)];
      style = {
        "background": randomPalette['background'],
        "color": randomPalette['color'],
        fontSize: Math.floor(Math.random() * 75) + 25,
        fontFamily: primary.name
      }
    }
    else {
      const randomPalette = textBorderPalettes[Math.floor(Math.random() * textBorderPalettes.length)];
      style = {
        "background": randomPalette['background'],
        "color": randomPalette['color'],
        "WebkitTextStroke": `2px ${randomPalette['border']}`,
        fontSize: Math.floor(Math.random() * 75) + 25,
        fontFamily: primary.name
      }
    }
    return style;
  }

  renderWord(word) {
    const style = this.getRandomStyle();
    return (
      <div
        key={uuid.v4()}
        className="word-container" style={style}>
        {word}
      </div>
    )
  }

  render() {

    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    const randomPangram = panagramsArr[Math.floor(Math.random() * panagramsArr.length)];
    const words = randomPangram.split(' ');
    return (
      <div>
        <div className="divider-wrapper">
          <div className="divider">
            <span style={styles.secondaryFont}>Word play</span>
          </div>
        </div>
        <div className="panagram-wrapper">
          {words.map((word) => {
            return this.renderWord(word)
          })}
        </div>
      </div>
    )
  }
}

export default Panagram = connect(mapStateToProps, undefined)(Panagram);



// WEBPACK FOOTER //
// ./src/components/generator/Panagram.jsx